// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{border-radius:2px;background-color:#f1f1f1}::-webkit-scrollbar-thumb{border-radius:2px;background-color:#a8a8a8}", ""]);
// Exports
module.exports = exports;
